module.exports = __webpack_public_path__ + "static/media/STANDARD_RAFFLE.5f3a0f7b.mp3";